import React, { Component } from "react";
import { ListingContext } from "../../Context";
import _ from "lodash";

import GoogleEmbedMap from "../../components/googleEmbedMap/googleEmbedMap";
import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingLocation extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const location = listing.location || {};
          if (listingContext.loading) {
            return (
              <div className="listing-location">
                <SkeletonText lines={3} />
                <div className="listing-location__map">
                  <div id="googleEmbedMaps" className="map" width="100%" />
                </div>
              </div>
            );
          } else if (!_.isEmpty(location)) {
            return (
              <div className="listing-location">
                <h5 className="listing-section__title">The Neighbourhood</h5>
                {location.area && (
                  <p className="listing-location__summary">
                    This home is located in the {location.area} area of{" "}
                    {location.city && `${location.city}.`}
                  </p>
                )}
                <div className="listing-location__map">
                  <GoogleEmbedMap />
                </div>
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingLocation.js